import { render, staticRenderFns } from "./BrickSquareEndpoints.vue?vue&type=template&id=0575d21e&"
import script from "./BrickSquareEndpoints.vue?vue&type=script&lang=js&"
export * from "./BrickSquareEndpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0575d21e')) {
      api.createRecord('0575d21e', component.options)
    } else {
      api.reload('0575d21e', component.options)
    }
    module.hot.accept("./BrickSquareEndpoints.vue?vue&type=template&id=0575d21e&", function () {
      api.rerender('0575d21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickSquareEndpoints.vue"
export default component.exports